<template>
    <div id="CaratulasDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloCaratulasDeDocumento_div">
            <h5 class="label-black" style="margin-bottom: 0px;">DOCUMENTOS</h5>
            <h6 class="label-black" style="margin-top: 0px;">Creación de Caratulas de legajos de Documentos</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area">
                    <div>
                        <select id="catalogodeCreacion" class="form-control" @change="cambiarTipo($event)">
                            <option value= 0>Seleccione un Tipo de Caratula</option>
                            <option v-for="option in TipoCreacion" v-bind:value="option.id" >{{ option.value }}</option>
                        </select>
                    </div>
                    <div v-if="TipoSeleccionado.Tipo==1">
                        <br/>
                        <Busqueda v-on:ValorDeConsulta="ObtenDatos($event)" :barCode=this.barraCode :IncidenteCode=this.CodigoARecibir :actualiza=this.ActualizaConsulta />
                    </div>
                    <div v-if="TipoSeleccionado.Tipo==2">
                        <br/>
                        <select id="catalogodeLegajos" class="form-control" @change="cambiarLegajo($event)">
                            <option value= 0>Seleccione Legajo</option>
                            <option v-for="option in TipoLegajo" v-bind:value="option.idTipo" >{{ option.value }}</option>
                        </select>
                        <br/>
                        <div class="form-group" id="AreasCatalogo" v-if="LSeleccionado.Tipo>0 && AreaConsulta== null">
                            <CAreas
                            v-on:valorParaElPadre="cambioDeArea" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoAreas'" 
                            :parametros="parametros_Area" 
                            :valorDefinido="parametros_Area.areaId" 
                            :key="parametros_Area.areaId"
                            >
                            </CAreas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area" v-if="DocumentoObtenido.InventarioDocumentoId>0 && TipoSeleccionado.Tipo ==1">
                    <div>
                        <h5 class="label-black">Información Principal</h5>
                        <hr>
                    </div>
                    <div class="row align-items-center">
                        <div class="form-group col-8" id="Area_div">
                            <label class="label-black">Área</label>
                            <input type="text" class="form-control" v-model="DocumentoObtenido.Area.Nombre" readonly />
                        </div>
                        <div class="form-group col-4" id="Materia_div" v-if="DocumentoObtenido.Materia != null">
                            <label class="label-black">Materia</label>
                            <input type="text" class="form-control" v-model="DocumentoObtenido.Materia.Nombre" readonly />
                        </div>
                    </div>
                    <div class="row align-items-center">
                            <div class="form-group col-4" id="TipoDocumento_div">
                                <label class="label-black">Tipo de Documento</label>
                                <input type="text" class="form-control" v-model="DocumentoObtenido.TipoDocumento.Nombre" readonly />
                            </div>
                            <div class="form-group col-4" id="Anio_div">
                                <label class="label-black">Año</label>
                                <input type="text" class="form-control " v-model="DocumentoObtenido.Anio" readonly />
                            </div>
                            <div class="form-group col-4" id="Consecutivo_div" v-if="DocumentoObtenido.Sufijo==null">
                                <label class="label-black">Consecutivo</label>
                                <input type="text" class="form-control" v-model="DocumentoObtenido.Consecutivo" readonly />
                            </div>
                            <div class="form-group col-2" id="Consecutivo_div" v-else>
                                <label class="label-black">Consecutivo</label>
                                <input type="text" class="form-control" v-model="DocumentoObtenido.Consecutivo" readonly />
                            </div>
                            <div class="form-group col-2" id="Consecutivo_div" v-if="DocumentoObtenido.Sufijo!=null">
                                <label class="label-black">Sufijo</label>
                                <input type="text" class="form-control" v-model="DocumentoObtenido.Sufijo" readonly />
                            </div>

                    </div>
                    <div v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId!=5">
                        <div v-if="DocumentoObtenido.Juicio!=null && DocumentoObtenido.Juicio.DocumentoId_Referencia >0 && (DocumentoObtenido.TipoDocumento.TipoDocumentoId!=23 && DocumentoObtenido.TipoDocumento.TipoDocumentoId!=24) && (DocumentoObtenido.Area.AreaId!=11 && DocumentoObtenido.Area.AreaId!=12 && DocumentoObtenido.Area.AreaId!=13 && DocumentoObtenido.Area.AreaId!=14 && DocumentoObtenido.Area.AreaId!=15 && DocumentoObtenido.Area.AreaId!=16)">
                            <h5 class="label-black">Información del Juicio</h5>
                        <hr>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.Juicio!=null && DocumentoObtenido.Juicio.DocumentoId_Referencia >0 && (DocumentoObtenido.TipoDocumento.TipoDocumentoId!=23 && DocumentoObtenido.TipoDocumento.TipoDocumentoId!=24) && (DocumentoObtenido.Area.AreaId!=11 && DocumentoObtenido.Area.AreaId!=12 && DocumentoObtenido.Area.AreaId!=13 && DocumentoObtenido.Area.AreaId!=14 && DocumentoObtenido.Area.AreaId!=15 && DocumentoObtenido.Area.AreaId!=16)">
                            <div class="form-group col-1" id="Estatus_div">
                                <label class="label-black"><b>Tipo:</b></label>
                            </div>
                            <div class="form-group col-5" id="Estatus_div">
                                <label class="label-black">{{DocumentoObtenido.Juicio.Juicio}}</label>
                            </div>
                            <div class="form-group col-1" id="Estatus_div">
                                <label class="label-black"><b>Tramite:</b></label>
                            </div>
                            <div class="form-group col-5" id="Estatus_div">
                                <label class="label-black">{{DocumentoObtenido.Juicio.Tramite}}</label>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            <h5 class="label-black">Información del Juicio</h5>
                            <hr>
                        </div>
                        <div class="row">
                            <div class="form-group col-3">
                                <label class="text-success"><b>Naturaleza del Juicio:</b></label>
                            </div>
                            <div class="form-group col-9">
                                <input type="text" class="form-control" v-model="datosJuicio.Juicio" placeholder="Tipo de juicio">
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-3">
                                <label class="text-success"><b>Objeto del Juicio:</b></label>
                            </div>
                            <div class="form-group col-9">
                                <input type="text" class="form-control" v-model="datosJuicio.Tramite" placeholder="tramite del juicio">
                            </div>
                        </div>
                    </div>
                    <div v-if="DocumentoObtenido.Area.AreaId==56 && DocumentoObtenido.TipoDocumento.TipoDocumentoId==23">
                        <h5 class="label-black">Información Complementaria</h5>
                        <hr>
                        <div class="row">
                            <div class="form-group col-12" id="datosCarpetaDigitalAdolescenteCoadyuvante_div">
                                <label class="text-success" v-if="DocumentoObtenido.DatosCarpeta.Coadyuvante!=null && DocumentoObtenido.DatosCarpeta.Coadyuvante!=''">Coadyuvante</label>
                                <label class="text-warning" v-else>Coadyuvante</label>
                                <input type="text" class="form-control" v-model="DocumentoObtenido.DatosCarpeta.Coadyuvante"/>
                            </div>
                            <div class="form-group col-12" id="datosCarpetaDigitalAdolescenteHechoPunible_div">
                                <label class="text-success" v-if="DocumentoObtenido.DatosCarpeta.HechoPunible!=null && DocumentoObtenido.DatosCarpeta.HechoPunible!=''">Hecho punible</label>
                                <label class="text-warning" v-else>Hecho punible</label>
                                <textarea type="text" rows="2" class="form-control" v-model="DocumentoObtenido.DatosCarpeta.HechoPunible"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="(DocumentoObtenido.Area.AreaId==19 ||DocumentoObtenido.Area.AreaId==26 || DocumentoObtenido.Area.AreaId==27 || DocumentoObtenido.Area.AreaId==44) && (DocumentoObtenido.TipoDocumento.TipoDocumentoId==16)">
                        <h5 class="label-black">Información Complementaria</h5>
                        <hr>
                        <div class="row">
                            <div class="form-group col-12" id="datosCarpetaDigitalAdolescenteCoadyuvante_div">
                                <label class="text-success" v-if="DocumentoObtenido.DatosCarpeta.Coadyuvante!=null && DocumentoObtenido.DatosCarpeta.Coadyuvante!=''">Contiene</label>
                                <label class="text-warning" v-else>Contiene</label>
                                <textarea type="text" rows ="3" class="form-control" v-model="DocumentoObtenido.DatosCarpeta.Coadyuvante"/>
                            </div>
                            <div class="form-group col-12" id="datosCarpetaDigitalAdolescenteHechoPunible_div">
                                <label class="text-success" v-if="DocumentoObtenido.DatosCarpeta.HechoPunible!=null && DocumentoObtenido.DatosCarpeta.HechoPunible!=''">Procede</label>
                                <label class="text-warning" v-else>Procede</label>
                                <input type="text"  class="form-control" v-model="DocumentoObtenido.DatosCarpeta.HechoPunible"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="DocumentoObtenido.Partes!=null && DocumentoObtenido.Partes.length>0 && DocumentoObtenido.TipoDocumento.TipoDocumentoId!=4">
                        <h5 class="label-black">Información de las Partes</h5>
                        <hr>
                        <div id="Partes_table" class="table-responsive">
                                <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-custom">
                                    <tr>
                                    <th>Parte</th>
                                    <th>Nombre</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-for="parte in DocumentoObtenido.Partes" :key="parte.Documento_Referencia">
                                    <td>{{parte.Tipo_Parte}}</td>
                                    <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                                    </tr>
                                </tbody>
                                </table>
                        </div>
                    </div>
                    <div v-if="DocumentoObtenido.Volumenes.length>0">
                        <div>
                        <h5 class="label-black">Tomos</h5>
                        </div>
                        <div id="Tomos_table" class="table-responsive">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                            <tr>
                                <th>No.</th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody class="text-dark">
                            <tr v-for="detalle in DocumentoObtenido.Volumenes" :key="detalle.VolumenId">
                                <td width="50">{{detalle.NumVolumen}}</td>
                                <td width="600">{{detalle.NumVolumen==1? 'PRINCIPAL': ''}}</td>
                                <td width="50">
                                    <a v-on:click="GenerarCaratula(DocumentoObtenido, true, detalle.NumVolumen)" title="Generar Caratula">
                                        <i class="fas fa-print"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div v-if="DocumentoObtenido.Tercerias.length>0">
                        <div>
                        <h5 class="label-black">Tercerías</h5>
                        </div>
                        <div id="Tercerias_table" class="table-responsive">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                            <tr>
                                <th>No.</th>
                                <th>Tipo Terceria</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody class="text-dark">
                            <tr v-for="detalle in DocumentoObtenido.Tercerias" :key="detalle.TerceriaId">
                                <td width="50">{{detalle.NumeroTerceria}}</td>
                                <td width="600">{{detalle.TipoTerceria}}</td>
                                <td width="50">
                                    <a v-on:click="GenerarCaratula(DocumentoObtenido, false, detalle.TerceriaId)" title="Generar Caratula">
                                        <i class="fas fa-print"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div v-if="DocumentoObtenido.Incidentes.length>0">
                        <div>
                        <h5 class="label-black">Incidentes</h5>
                        </div>
                        <div id="Incidentes_table" class="table-responsive">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                            <tr>
                                <th>No.</th>
                                <th>Tipo Incidente</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody class="text-dark">
                            <tr v-for="detalle in DocumentoObtenido.Incidentes" :key="detalle.IncidenteId">
                                <td width="50">{{detalle.NumeroIncidente}}</td>
                                <td width="600">{{detalle.TipoIncidente}}</td>
                                <td width="50">
                                    <a v-on:click="GenerarCaratula(DocumentoObtenido, false, detalle.IncidenteId)" title="Generar Caratula">
                                        <i class="fas fa-print"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div v-if="(DocumentoObtenido.Area.AreaId==19 ||DocumentoObtenido.Area.AreaId==26 || DocumentoObtenido.Area.AreaId==27 || DocumentoObtenido.Area.AreaId==44) && (DocumentoObtenido.TipoDocumento.TipoDocumentoId==4)">
                        <h5 class="label-black">Información Complementaria</h5>
                        <hr>
                        <div class="row">
                            <div class="form-group col-12" id="datosCarpetaDigitalAdolescenteCoadyuvante_div">
                                <label class="text-success" v-if="DocumentoObtenido.DatosCarpeta.Coadyuvante!=null && DocumentoObtenido.DatosCarpeta.Coadyuvante!=''">Contiene</label>
                                <label class="text-warning" v-else>Contiene</label>
                                <textarea type="text" rows="5" class="form-control" v-model="DocumentoObtenido.DatosCarpeta.Coadyuvante"/>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4">
                        <div class="form-group col-6" id="antecendente_div">
                            <label class="label-black">Antecedente:</label>
                            <input type="text" class="form-control" v-model="AntecedenteAmparo" readonly />
                        </div>
                        <div class="form-group col-6" id="antecendente_div" v-if="DocumentoObtenido.Materia.MateriaId!=6">
                            <label class="label-black">Tipo de Amparo:</label>
                            <select id="catalogodeAmparos" class="form-control" @change="cambiarAmparo($event)">
                                <option value= 0>Seleccione un Tipo de Amparo</option>
                                <option v-for="option in TipoAmparo" v-bind:value="option.idAmparo" >{{ option.value }}</option>
                            </select>
                        </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4">
                            <div class="form-group col-12" id="antecendente_div">
                                <label v-if="DocumentoObtenido.Materia.MateriaId!=6">Autoridad Federal ante quien se tramita:</label>
                                <label v-else>Procedencia:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Autoridad"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Quejoso:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Quejoso"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId!=6 && DocumentoObtenido.AmparoDocumentoPrincipal!=null">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Parte Actora:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Actora"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId!=6 && DocumentoObtenido.AmparoDocumentoPrincipal!=null">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Parte demandada:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Demandada"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId==6">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Reclamado(s):</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Reclamado"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId==6">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Juez:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Juez"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId==6">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">Secretario (a):</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.Secretaria"/>
                            </div>
                        </div>
                        <div class="row" v-if="DocumentoObtenido.TipoDocumento.TipoDocumentoId==4 && DocumentoObtenido.Materia.MateriaId==6">
                            <div class="form-group col-12" id="antecendente_div">
                                <label class="label-black">M.P.:</label>
                                <input type="text" class="form-control" v-model="DatosAmparo.MP"/>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="area" v-if="LSeleccionado.Tipo!=0 && TipoSeleccionado.Tipo ==2 && ( parametros_Area.areaId>0 || AreaConsulta!=null)">
                    <div class="form-group col-4" id="anio_div" v-if="LSeleccionado.Tipo==1 || LSeleccionado.Tipo==5 || LSeleccionado.Tipo==6 || LSeleccionado.Tipo==7 || LSeleccionado.Tipo==8">
                            <label class="label-black">Fecha en Caratula:</label>
                            <input class="form-control" type="month"  v-model="Fecha"/>
                    </div>
                    <div class="form-group col-4" id="anio_div" v-if="LSeleccionado.Tipo==2 || LSeleccionado.Tipo==4">
                            <label v-if="LSeleccionado.Tipo==2">Expediente:</label>
                            <label v-if="LSeleccionado.Tipo==4">Exhorto:</label>
                            <input class="form-control" type="text"  v-model="Expediente" placeholder="####/####" v-mask="'####/####'"/>
                    </div>
                    <div class="form-group col-6" id="anio_div" v-if="LSeleccionado.Tipo==3">
                            <label class="label-black">No. de Amparo Interno:</label>
                            <input class="form-control" type="number"  v-model="AmparoInterno"/>
                    </div>
                    <div class="form-group col-6" id="anio_div" v-if="LSeleccionado.Tipo==3">
                            <label class="label-black">No. de Amparo Juzgado de Distrito:</label>
                            <input class="form-control" type="number"  v-model="AmparoDistrito"/>
                    </div>
                    <div class="form-group col-6" id="anio_div" v-if="LSeleccionado.Tipo==3">
                            <label class="label-black">Quejoso:</label>
                            <input class="form-control" type="text"  v-model="Quejoso"/>
                    </div>

                    <div class="form-group col-4 text-right" id="obtener_div">
                        <button class="btn btn-secondary btn-sm" @click='GenerarLegajo()'>Descargar Caratula para Legajo</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import enumeraciones from '@/../static/js/enumeraciones'
import VueMask from 'v-mask'


Vue.use(VueMask);

export default {
    components:{
        Busqueda: FiltroDeBusqueda,
        CAreas : catalogos.ArchivoJudicial.C001Areas,
    },
    props: {
        barraCode: {
            type: String,
            default: ""
        }
    },
    data(){
        return{
            enumeraciones,
            AreaConsulta: null,
            parametros_Area: {
                        areaId: -1,
                        nombre: "",
                        conMaterias: false,
                    },
            CodigoARecibir: "",
            ActualizaConsulta:{
                type: Boolean,
                default: false,
            },
            DocumentoObtenido: {
                InventarioDocumentoId: 0,
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Anio: "",
                Consecutivo: "",
                CodigoBarras: "",
                FechaRegistro: null,
                FechaRegistroArchivo: null,
                TipoEstatusInventario: {},
                SedeArchivo:{},
                Volumenes :[],
                Partes: [],
                Referencias: [],
                Juicio: {},
                BaseDatos: {},
                DatosCarpeta: {
                    Coadyuvante : null,
                    Hecho: null
                }
            },
            TipoCreacion: [
                {id: 1, value: "Caratulas de Documentos"},
                {id: 2, value: "Caratulas de Legajos"},
            ],
            TipoSeleccionado: {Tipo: 0},
            TipoLegajo : [
                {idTipo: 1, value: "Listas de Acuerdos"},
                {idTipo: 2, value: "Copias Certificadas del Expediente"},
                {idTipo: 3, value: "Amparo sin Antecedentes"},
                {idTipo: 4, value: "Copia de Exhorto"},
                {idTipo: 5, value: "Promociones con numero Equivocado"},
                {idTipo: 6, value: "Entrega de Expedientes a Recepción de Dirección de Notificadores"},
                {idTipo: 7, value: "Oficios (Correspondencia)"},
                {idTipo: 8, value: "Formato de Control y Envío de Correspondencia"},

            ],
            TipoAmparo: [
                { idAmparo: 1, value :"DIRECTO"},
                { idAmparo: 2, value :"INDIRECTO"}
            ],
            LSeleccionado: {Tipo : 0},
            Fecha: moment().format('YYYY-MM'),
            Expediente: "",
            Quejoso: "",
            AmparoInterno: "",
            AmparoDistrito: "",
            AntecedenteAmparo: 'SIN ANTECEDENTE',
            DatosAmparo : {
                Autoridad: '',
                Tipo: '',
                Quejoso: "",
                Actora: "",
                Demandada: "",
                Reclamado: "",
                Juez: "",
                Secretaria : "",
                MP:""
            },
            parametroa_Amparo:
            {
                tipoAmparo: 0,
                Nombre: ''
            },
            datosJuicio : {
                DocumentoId_Referencia: 0,
                Juicio:"",
                Tramite: ""
            },
            mostralModal :false,
            partesModal :[]
            
        }
    },
    methods: {
        cambiarTipo(evento)
        {
            if(evento.target.value!= 0)
            {
                this.TipoSeleccionado.Tipo = parseInt(evento.target.value);
                this.LSeleccionado.Tipo = 0;
                this.DocumentoObtenido.InventarioDocumentoId = 0;
            }
            else 
            {
                this.TipoSeleccionado.Tipo = 0;
            }
        },
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.parametros_Area.nombre = datos[0].target.selectedOptions[0].text;
        },
        cambiarLegajo(evento){
            if(evento.target.value!= 0)
            {
                this.LSeleccionado.Tipo = parseInt(evento.target.value);

            }
            else 
            {
                this.LSeleccionado.Tipo = 0;
            }
            this.Expediente="";
            this.Quejoso="";
            this.AmparoInterno ="";
            this.AmparoDistrito ="";
        },
        ObtenDatos(datos){
            this.datosJuicio.DocumentoId_Referencia= 0;
            this.datosJuicio.Juicio='';
            this.datosJuicio.Tramite = '';
            this.DocumentoObtenido = datos.DocumentoConsulta;
            if(datos.InfoIncidente!=null)
            {
                this.DocumentoObtenido.Incidentes.push(datos.InfoIncidente)
            };
            if(datos.InfoTerceria!=null)
            {
                this.DocumentoObtenido.Tercerias.push(datos.InfoTerceria)
            }
            if(this.DocumentoObtenido.TipoDocumento.TipoDocumentoId==5)
            {
                this.datosJuicio.DocumentoId_Referencia= this.DocumentoObtenido.Juicio.DocumentoId_Referencia;
                this.datosJuicio.Juicio=this.DocumentoObtenido.Juicio.Juicio;
                this.datosJuicio.Tramite = this.DocumentoObtenido.Juicio.Tramite;
            };
            this.parametroa_Amparo.tipoAmparo = 0;
            $("#catalogodeAmparos option[value='0']").prop("selected",true);
            this.DatosAmparo.Juicio = '';
            this.DatosAmparo.Autoridad = '';
            this.DatosAmparo.Quejoso='';
            this.DatosAmparo.Actora = '';
            this.DatosAmparo.Demandada='';
            if(this.DocumentoObtenido.AmparoDocumentoPrincipal!=null)
            {
                this.AntecedenteAmparo = 'Exp. Principal : ' + this.DocumentoObtenido.AmparoDocumentoPrincipal.Consecutivo + '/' +this.DocumentoObtenido.AmparoDocumentoPrincipal.Anio
            }
            else
            {
                this.AntecedenteAmparo= "SIN ANTECEDENTE";
                this.DatosAmparo.Quejoso = this.ObtenerInfo(this.DocumentoObtenido.Partes);
            }
            if(this.DocumentoObtenido.Area.AreaId==56 && this.DocumentoObtenido.TipoDocumento.TipoDocumentoId==23)
            {
                comun.mensajeDeAlerta("Para generar la caratula es posible agregar o editar datos en información complementaria.", null, null);
            }
        },
        GenerarCaratula: function (documento, Tomo, Numero){
            if(documento.TipoDocumento.TipoDocumentoId==4)
            {
                if(documento.Area.AreaId!=26 && documento.Area.AreaId!=27)
                {
                    if(this.parametroa_Amparo.tipoAmparo>0)
                    {
                        let peticion = { documento, 
                                    'Tipo': this.parametroa_Amparo.Nombre,
                                    'Autoridad' : this.DatosAmparo.Autoridad,
                                    'Quejoso': this.DatosAmparo.Quejoso,
                                    'Actora': this.DatosAmparo.Actora,
                                    'Demandada': this.DatosAmparo.Demandada,
                                    'Tomos': Tomo,
                                    'NumeroElemento': Numero}
                        axios.post(api.conexion + api.ArchivoJudicial.ObtenerCaratula, peticion,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                        .then( respuesta => {
                            if(respuesta.data.SiHayError)
                            {
                                comun.SeEstaCargandoInformacion(false);
                                console.log(respuesta);
                                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            }
                            else
                            {   
                                let archivo = respuesta.data.caratula;
                                if(archivo!=null && archivo!=undefined && archivo!="")
                                {
                                    window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + archivo.OriginalPath, '_blank');
                                }
                            }
                            comun.SeEstaCargandoInformacion(false);
                        
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        });
                    }
                    else
                    {
                        if(documento.Materia.MateriaId==6)
                        {
                            let peticion = { documento, 
                                    'Tipo': this.parametroa_Amparo.Nombre,
                                    'Autoridad' : this.DatosAmparo.Autoridad,
                                    'Quejoso': this.DatosAmparo.Quejoso,
                                    'Actora': this.DatosAmparo.Actora,
                                    'Demandada': this.DatosAmparo.Demandada,
                                    'Reclamo' : this.DatosAmparo.Reclamado,
                                    'Juez': this.DatosAmparo.Juez,
                                    'Secretaria': this.DatosAmparo.Secretaria,
                                    'MP': this.DatosAmparo.MP,
                                    'Tomos': Tomo,
                                    'NumeroElemento': Numero}
                            console.log(peticion)
                            axios.post(api.conexion + api.ArchivoJudicial.ObtenerCaratula, peticion,
                            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                            .then( respuesta => {
                                if(respuesta.data.SiHayError)
                                {
                                    comun.SeEstaCargandoInformacion(false);
                                    console.log(respuesta);
                                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                                }
                                else
                                {   
                                    let archivo = respuesta.data.caratula;
                                    if(archivo!=null && archivo!=undefined && archivo!="")
                                    {
                                        window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + archivo.OriginalPath, '_blank');
                                    }
                                }
                                comun.SeEstaCargandoInformacion(false);
                            
                            })
                            .catch(excepcion => {
                                console.log(excepcion);
                                console.log("fallo por parametros");
                                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                                comun.SeEstaCargandoInformacion(false);
                            })
                        }
                        else
                        {
                            comun.mensajeDeAlerta("Seleccione un tipo de Amparo", null, null);
                        }
                    }
                }
                else
                {
                    if((documento.Area.AreaId==26 || documento.Area.AreaId==27) && (documento.TipoDocumento.TipoDocumentoId==4 || documento.TipoDocumento.TipoDocumentoId==16))
                {
                    if(documento.DatosCarpeta.DatoCarpetaId==0)
                    {
                        documento.DatosCarpeta.InventarioDocumentoId = documento.InventarioDocumentoId;
                    }
                }
                let peticion = {documento, 'Tomos': Tomo, 'NumeroElemento': Numero};
                axios.post(api.conexion + api.ArchivoJudicial.ObtenerCaratula, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {   
                        console.log(respuesta)
                        let archivo = respuesta.data.caratula;
                        if(archivo!=null && archivo!=undefined && archivo!="")
                        {
                            window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + archivo.OriginalPath, '_blank');
                        }
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                })
                }
            }
            else
            {
                
                if(documento.TipoDocumento.TipoDocumentoId==5)
                {
                    documento.Juicio=this.datosJuicio;
                };
                if(documento.Area.AreaId==56 && documento.TipoDocumento.TipoDocumentoId==23)
                {
                    if(documento.DatosCarpeta.DatoCarpetaId==0)
                    {
                        documento.DatosCarpeta.InventarioDocumentoId = documento.InventarioDocumentoId;
                    }
                }

                if((documento.Area.AreaId==19 ||documento.Area.AreaId==26 || documento.Area.AreaId==27 || documento.Area.AreaId==44) && (documento.TipoDocumento.TipoDocumentoId==4 || documento.TipoDocumento.TipoDocumentoId==16))
                {
                    if(documento.DatosCarpeta.DatoCarpetaId==0)
                    {
                        documento.DatosCarpeta.InventarioDocumentoId = documento.InventarioDocumentoId;
                    }
                }
                let peticion = {documento, 'Tomos': Tomo, 'NumeroElemento': Numero};
                axios.post(api.conexion + api.ArchivoJudicial.ObtenerCaratula, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {   
                        
                        let archivo = respuesta.data.caratula;
                        if(archivo!=null && archivo!=undefined && archivo!="")
                        {
                            window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + archivo.OriginalPath, '_blank');
                        }
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                })
            }
            
        },
        GenerarLegajo(){
            let peticion = this.AreaConsulta ==null ? {
                Area : {"AreaId": this.parametros_Area.areaId, 
                        "Nombre": this.parametros_Area.nombre.toUpperCase(),
                        "Abreviatura": "Archivo"},
                TipoLegajo: this.LSeleccionado.Tipo,
                Fecha: this.Fecha,
                Expediente : this.Expediente,
                Quejoso: this.Quejoso,
                AmpInt: this.AmparoInterno,
                AmpJDistrito: this.AmparoDistrito
            } : {Area : this.AreaConsulta,
                TipoLegajo: this.LSeleccionado.Tipo,
                Fecha: this.Fecha,
                Expediente : this.Expediente,
                Quejoso: this.Quejoso,
                AmpInt: this.AmparoInterno,
                AmpJDistrito: this.AmparoDistrito
            };
            
            if(this.validaDatosLejagos(this.LSeleccionado.Tipo))
            {
                axios.post(api.conexion + api.ArchivoJudicial.ObtenerLegajo, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {   
                        this.Expediente="";
                        this.Quejoso="";
                        this.AmparoInterno ="";
                        this.AmparoDistrito ="";
                        let archivo = respuesta.data.caratula;
                        if(archivo!=null && archivo!=undefined && archivo!="")
                        {
                            window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + archivo.OriginalPath, '_blank');
                        }
                    }
                    comun.SeEstaCargandoInformacion(false);
                        
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                })
            }
        },
        validaDatosLejagos(id){
            const Separado = this.Expediente.split("/");
            switch (id){
                case 2:
                    if(this.Expediente=="" || this.Expediente == undefined || this.Expediente == null)
                    {
                        comun.mensajeDeAlerta("Ingrese el numero del Expediente", null, null);
                        return false
                    }
                    if(parseInt(Separado[0])==0 || parseInt(Separado[1])==0)
                    {
                        comun.mensajeDeAlerta("Ingrese un Expediente Valido", null, null);
                        return false
                    };
                    if(Separado[0].length<4 || Separado[1].length<4)
                    {
                        comun.mensajeDeAlerta("Longitud del numero de expediente no valido", null, null);
                        return false
                    };
                    break;
                case 3:
                    if(this.AmparoInterno=="" || this.AmparoInterno== null || this.AmparoInterno== undefined )
                    {
                        comun.mensajeDeAlerta("Ingrese el numero del amparo interno", null, null);
                        return false
                    }
                    if(parseInt(this.AmparoInterno)<1)
                    {
                        comun.mensajeDeAlerta("El numero del amparo interno debe ser valido", null, null);
                        return false
                    }
                    if(this.AmparoDistrito=="" || this.AmparoDistrito== null || this.AmparoDistrito== undefined)
                    {
                        comun.mensajeDeAlerta("Ingrese el numero del amparo en Juzgado de Distrito", null, null);
                        return false
                    }
                    if(parseInt(this.AmparoDistrito)<1)
                    {
                        comun.mensajeDeAlerta("El numero del amparo del Juzgado de Distrito debe ser valido", null, null);
                        return false
                    }
                    if(this.Quejoso=="" || this.Quejoso== null || this.Quejoso== undefined)
                    {
                        comun.mensajeDeAlerta("Ingrese el nombre del quejoso", null, null);
                        return false
                    };
                    break;
                case 4:
                    if(this.Expediente=="" || this.Expediente == undefined || this.Expediente == null)
                    {
                        comun.mensajeDeAlerta("Ingrese el numero del Exhorto", null, null);
                        return false
                    };
                    if(parseInt(Separado[0])==0 || parseInt(Separado[1])==0)
                    {
                        comun.mensajeDeAlerta("Ingrese un Exhorto Valido", null, null);
                        return false
                    };
                    if(Separado[0].length<4 || Separado[1].length<4)
                    {
                        comun.mensajeDeAlerta("Longitud del numero de expediente no valido", null, null);
                        return false
                    };
                    break;
            }
            return true;
        },
        cambiarAmparo(evento)
        {
            this.parametroa_Amparo.tipoAmparo = parseInt(evento.target.value)
            this.parametroa_Amparo.Nombre =evento.target.selectedOptions[0].text;
        },
        ObtenerInfo: function(partes){
            let contenido =''
            if(partes!=null && partes.length>0)
            {
                $.each(partes, function(id, dato)
                {
                    if(dato.Tipo_Parte=='QUEJOSO')
                    {
                        contenido =contenido + dato.Nombre + ' ' + dato.ApellidoPaterno + ' ' + dato.ApellidoMaterno + ', ';
                    }
                    
                })
            }
            
            return contenido;
        }
    },
    mounted(){
        if(this.$store.state.Login_Usuario.Area.AreaId!=21)
        {
             this.AreaConsulta = this.$store.state.Login_Usuario.Area;
        }
        this.LejagoSeleccionado = 0;
    }
}
</script>
<style scoped>
    input[type="text"]:read-only {
        background: #f3f3f3;
    }
    input[type="text"]:read-only:focus {
      color: #fff;
    }
    textarea[type="text"]:read-only {
        background: #504f54;
    }
    textarea[type="text"]:read-only:focus {
        color: #fff;
    }
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
        .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/Caratulas.vue